module.exports = __webpack_public_path__ + "static/img/image_solutions_hpc_01.7ae5a83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_hpc_01.png
// module id = REBK
// module chunks = 10